import React, { useContext } from 'react';
import { EventDetailsContext } from '../../context/event_details.context';

interface Props {
  displayTimezone: boolean;
}

const StartTime: React.FC<Props> = ({ displayTimezone }: Props) => {
  const { event } = useContext(EventDetailsContext);
  if (!event?.starts_at) return null;

  const options: Intl.DateTimeFormatOptions = {
    hour12: true,
    hour: 'numeric',
    minute: '2-digit',
  };

  if (displayTimezone) {
    options.timeZoneName = 'short';
  }

  return (
    <span data-testid='formatted-start-time' className='text-uppercase'>
      {new Date(event?.starts_at).toLocaleTimeString(undefined, options)}
    </span>
  );
};

export default StartTime;
